import { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaGoogle, FaBackward } from "react-icons/fa";
import Logo from "../assest/l.png";
import { loginMatrimonyUser } from "../utils/api";
import { useAuth } from "../utils/authContext"

const MatrimonyLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isCoFounder, setIsCoFounder] = useState(false);
  const [loading, setLoading] = useState(false);
  const { loginMatrimony } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      // 1. Call your API
      const resp = await loginMatrimonyUser(email, password);

      // 2. Normalize response
      const result = resp.data ? resp.data : resp;
      const { user, token } = result;

      if (!user) {
        throw new Error("Login succeeded but no user returned");
      }

      // 3. Clear any startup data
      localStorage.removeItem("startupId");
      localStorage.removeItem("fullName");
      localStorage.removeItem("email");
      localStorage.removeItem("Startuptoken");
      localStorage.removeItem("startupName");
      localStorage.removeItem("logoUrl");
      localStorage.removeItem("userPhone");

      // 4. Store Matrimony user data - MATCHING REGISTRATION FLOW
      const displayName = user.name || user.full_name || user.username || "";
      localStorage.setItem("matrimonyUserId", user.id);
      localStorage.setItem("matrimonyUserName", displayName);
      localStorage.setItem("matrimonyUserEmail", user.email);

      if (user.founder_id) {
        localStorage.setItem("UserFounderId", user.founder_id);
      }
      if (user.startup_id) {
        localStorage.setItem("UserStartupId", user.startup_id);
      }

      if (token) {
        localStorage.setItem("matrimonyToken", token);
        loginMatrimony(token);
      }

      setSuccess(true);
      navigate("/matrimony", { replace: true });

    } catch (err) {
      console.error(err);
      setError(err.message || "Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full h-[100dvh] lg:h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
      {/* Logo */}
      <div className="absolute top-10 left-10">
        <Link to="/">
          <img src={Logo} alt="Tactos Logo" className="w-28" />
        </Link>
      </div>

      <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
        {/* Form Section */}
        <div className="md:w-1/2 w-full bg-white px-8 py-6 h-full flex flex-col justify-center items-center">
          <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
            Welcome Back
          </h2>

          {success ? (
            <div className="text-center mt-6">
              <h3 className="text-2xl font-semibold text-green-600 mb-4">
                🎉 Login Successful!
              </h3>
              <p className="text-gray-600 mb-4">
                Redirecting to your Homepage...
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="space-y-5 text-sm w-full lg:w-1/2 mx-auto"
            >
              {error && (
                <motion.div
                  initial={{ y: -10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.2 }}
                  className="bg-red-100 text-red-700 p-3 rounded text-sm"
                >
                  {error}
                </motion.div>
              )}

              <div className="flex flex-col">
                <label
                  htmlFor="email"
                  className="text-gray-700 font-medium mb-1"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                  placeholder="Your Email"
                />
              </div>

              <div className="flex flex-col">
                <label
                  htmlFor="password"
                  className="text-gray-700 font-medium mb-1"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                  placeholder="Your Password"
                />
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center gap-2 px-6 py-2 bg-[#4b154c] text-white rounded-full hover:opacity-90 text-sm disabled:opacity-50"
                >
                  {loading && (
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  )}
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>

              <div className="flex justify-center mb-6">
                <span className="text-gray-600 text-sm">
                  Don't have an account?{" "}
                  <Link
                    to="/matrimony-register"
                    className="text-indigo-600 hover:underline"
                  >
                    Sign up
                  </Link>
                </span>
              </div>
            </form>
          )}
        </div>

        {/* Illustration */}
        <div className="md:w-1/2 w-full relative overflow-hidden lg:h-full hidden lg:block">
          <img
            src="/matri.avif"
            alt="Startup Illustration"
            className="w-full lg:h-full object-cover"
          />

          <Link
            to="/"
            className="absolute top-4 right-4 flex items-center gap-2 text-black font-bold"
          >
            <FaBackward /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MatrimonyLogin;
